// List of rules
export const BusinessRuleListReport = 'BusinessRule.List.Report';
export const BusinessRuleListActionFilter = 'BusinessRule.List.ActionFilter';
export const BusinessRuleListActionUpdatedbyFilter = 'BusinessRule.List.ActionUpdatedbyFilter';
export const BusinessRuleListActiveFilter = 'BusinessRule.List.ActiveFilter';
export const BusinessRuleListActiveToggle = 'BusinessRule.List.ActiveToggle';
export const BusinessRuleListInActiveToggle = 'BusinessRule.List.InActiveToggle';
export const BusinessRuleListDuplicate = 'BusinessRule.List.Duplicate';
export const BusinessRuleListDelete = 'BusinessRule.List.Delete';
export const BusinessRuleListEditIcon = 'BusinessRule.List.EditIcon';
export const BusinessRuleListDoubleclick = 'BusinessRule.List.Doubleclick';
export const BusinessRuleListDragging = 'BusinessRule.List.Dragging';
export const BusinessRuleListNew = 'BusinessRule.List.New';
export const BusinessRuleListHelp = 'BusinessRule.List.Help';

// Creating/Editing A Rule
export const BusinessRuleHelp = 'BusinessRule.Help';
export const BusinessRuleSendMailUsers = 'BusinessRule.SendMail.Users';
export const BusinessRuleSendMailEmails = 'BusinessRule.SendMail.Emails';
export const BusinessRuleSendMailSendText = 'BusinessRule.Send.text';
export const BusinessRuleOpenTask = 'BusinessRule.OpenTask';
export const BusinessRuleSendNoti = 'BusinessRule.SendNoti';
export const BusinessRulewebHook = 'BusinessRule.webHook';
export const BusinessRuleVerification = 'BusinessRule.Verification';
